// extracted by mini-css-extract-plugin
var _1 = "t2Lc";
var _2 = "t2K2";
var _3 = "t2K9";
var _4 = "t2K8";
var _5 = "t2K4";
var _6 = "t2K_";
var _7 = "t2K6";
var _8 = "t2K1";
var _9 = "t2K-";
var _a = "t2K3";
var _b = "t2Lb";
var _c = "t2La";
var _d = "t2K7";
var _e = "t2K5";
export { _1 as "comviq", _2 as "container", _3 as "content", _4 as "footer", _5 as "header", _6 as "image", _7 as "list", _8 as "modal", _9 as "promotion", _a as "show", _b as "subtitle", _c as "terms", _d as "text", _e as "title" }
